import React from 'react';
import { Col, Row } from 'antd';

import { Title } from './Title';
import type { ToolsToolTip } from './types';
import type { ErgonomicTools } from '@/hooks';
import { InfoBox } from '@/components/ui/InfoBox';
import { ToolCardsContent } from './ToolCardsContent';

const OUTER_GUTTER: [number, number] = [0, 12];
const FULL_SPAN = 24;

export interface ToolCardGroupProps {
	fileId: string;
	tools: ErgonomicTools[];
	isActive: (tool: ErgonomicTools) => boolean;
	showInfoBox?: boolean;
	infoBoxMessage?: string;
	toolsTooltip?: ToolsToolTip;
	fixedCardWidth?: boolean;
}

export function ToolCardGroup({
	fileId,
	tools,
	isActive,
	showInfoBox = false,
	infoBoxMessage = '',
	toolsTooltip,
	fixedCardWidth = false
}: Readonly<ToolCardGroupProps>): JSX.Element {
	return (
		<Row gutter={OUTER_GUTTER}>
			<Col span={FULL_SPAN} style={{ padding: 0 }}>
				<Title />
			</Col>
			{showInfoBox && infoBoxMessage && (
				<Col span={FULL_SPAN}>
					<InfoBox type="info" message={infoBoxMessage} />
				</Col>
			)}
			<Col span={FULL_SPAN}>
				<ToolCardsContent
					fileId={fileId}
					tools={tools}
					isActive={isActive}
					toolsTooltip={toolsTooltip}
					fixedCardWidth={fixedCardWidth}
				/>
			</Col>
		</Row>
	);
}
